<template>
  <div v-loading="loading" style="width: 100%;height: 100%">
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}</li>
          <li>项&nbsp;&nbsp;&nbsp;&nbsp;目&nbsp;&nbsp;&nbsp;&nbsp;点：{{ data[0].PROJECT_NAME }}</li>
          <li>项目点地址：{{ data[0].PROJECT_ADDRESS }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}</li>
          <li>档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：{{ data[0].DK_NAME }}</li>
          <li>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话：{{ data[0].PROJECT_TELPHONE }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="45" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="COST_PRICE" label="成本价（元）"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="销售价（元）"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="数量（kg）"></el-table-column>
          <el-table-column prop="REAL_COST" label="总成本（元）"></el-table-column>
          <el-table-column prop="REAL_FEE" label="总收入（元）"></el-table-column>
          <el-table-column prop="PROFIT" label="盈亏（元）">
            <template slot-scope="scope">
              <span style="color: red" v-if="Number(scope.row.PROFIT) <= 0">{{ scope.row.PROFIT }}</span>
              <span v-else>{{ scope.row.PROFIT }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--<el-row :data="data">-->
    <!--<el-col>-->
    <!--<p>收货时间：</p>-->
    <!--</el-col>-->
    <!--</el-row>-->
    <!--<el-row>-->
    <!--<el-col :span="6">-->
    <!--<p>送货员：</p>-->
    <!--</el-col>-->
    <!--<el-col :span="6">-->
    <!--<p>项目经理：</p>-->
    <!--</el-col>-->
    <!--<el-col :span="6">-->
    <!--<p>厨师长：</p>-->
    <!--</el-col>-->
    <!--<el-col :span="6">-->
    <!--<p>验收人员：</p>-->
    <!--</el-col>-->
    <!--</el-row>-->
  </div>
</template>
<script>
import http from '@/assets/common/http';
import bus from '@/assets/common/bus';

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      status: sessionStorage.getItem('orderStatus'),
      submitStatus: sessionStorage.getItem('submitStatus'),
      data: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      managername: sessionStorage.getItem('name'),
    };
  },
  methods: {
    queryOrderDetailListData() {
      const data = {
        ORDER_ID: sessionStorage.getItem('orderId'),
        SERVICE_ID: '10042',
        OTYPE: 7,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(data).then((result) => {
        this.tableData = result.length > 0 ? result[0].DETAIL : [];
        this.data = result.length > 0 ? result[0].TITLE : [];
        this.loading = false;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
  mounted() {
    this.queryOrderDetailListData();
  },
  destroyed() {
    bus.$emit('submit', this.tableData);
  },
};
</script>
<style scoped>
.ma img {
  width: 105px
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/costCenter/orderProfitDetail.vue